import React from 'react';
import Input from './Input';

const SecretField = ({...props}) => <Input {...props} type="password" />;

export default SecretField;
